export default "__VITE_ASSET__D77LKxPq__"